import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import { useTranslate } from "react-polyglot";
import EmployeeDialog from "./EmployeeDialog.jsx";
import ChatListContent from "./ChatListContent.jsx";
import ChatListHeader from "./ChatListHeader.jsx";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";
import { useAuth } from "../../../../Providers/Auth/AuthProvider.jsx";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    borderRight: `2px solid ${theme.palette.borderColor.main}`,
    width: 300,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  floatingPlus: {
    position: "absolute",
    bottom: 15,
    right: 15,
    borderRadius: "50%",
    padding: 10,
    minWidth: 0,
  },
}));

/**
 * Компонент списка чатов (левая панель).
 * Отображает заголовок, контент и плавающую кнопку для создания нового диалога.
 */
const ChatList = () => {
  const { subject } = useAuth();
  const classes = useStyles();
  const t = useTranslate();
  const { getEmployees, conversations, employees } = useChat();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [availableEmployees, setAvailableEmployees] = useState([]);

  /** */
  const handleOpen = () => setDialogOpen(true);

  /** */
  const handleClose = () => setDialogOpen(false);

  // Загрузка сотрудников
  useEffect(() => {
    getEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subject?.subjectId]);

  // Вычисление доступности кнопки создания диалога
  useEffect(() => {
    if (!employees) return;
    if (!conversations) return;
    const availableEmployees = employees.filter((emp) => !conversations.some((conv) => conv.userId === emp.id));
    setButtonVisible(availableEmployees.length > 0);
    setAvailableEmployees(availableEmployees);
  }, [conversations, employees]);

  return (
    <Box className={classes.root}>
      <ChatListHeader />
      <ChatListContent />
      {isButtonVisible && (
        <Tooltip title={t("chat.startDialogTooltip") || ""} placement="left">
          <Button color="primary" className={classes.floatingPlus} onClick={handleOpen} variant="contained">
            <AddIcon />
          </Button>
        </Tooltip>
      )}
      <EmployeeDialog open={dialogOpen} onClose={handleClose} employees={availableEmployees} />
    </Box>
  );
};

export default ChatList;
